import React, { Component } from 'react'
// import { Row, Col } from 'antd'
import moment from 'moment'

export default class Description extends Component {
  render () {
    const { startDate, endDate } = this.props
    function toDay (time) {
      return moment(time).format('DD')
    }
    function toMonth (time) {
      return moment(time).format('MMMM')
    }
    const dateRender = ({startDate, endDate}) => {
      if (endDate) {
        return `${toDay(startDate)} ${toMonth(startDate)} - ${moment(endDate).format('Do MMMM YYYY')}`
      } else {
        return `${moment(startDate).format('Do MMMM YYYY')}`
      }
    }
    return (
      <div style={{ paddingTop: '6px' }}>
        <div className="eventDateBox">
          <div className="dateBoxText">
            {dateRender({startDate, endDate})}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/EventPage/Components/Description.js